const { TiaraTracker } = window;

export default defineNuxtPlugin((nuxtApp) => {
  const config = {
    svcDomain: 'dktechin.com',
  };

  TiaraTracker.getInstance().init(config);
  TiaraTracker.getInstance().setAutoClick(true);
});
